import reducer from './reducers';
import * as bookAnalysesActions from './actions';
import * as bookAnalysesSelectors from './selectors';

export { bookAnalysesActions, bookAnalysesSelectors };
export default reducer;
